(function(){
  // Only run on product pages
  if (!window.location.pathname.startsWith('/products/')) return;

  // Load Judge.me CSS
  var css = document.createElement('link');
  css.rel = 'stylesheet';
  css.href = 'https://cdn.judge.me/assets/installed.css';
  document.head.appendChild(css);

  // Set Judge.me config
  window.jdgm = window.jdgm || {};
  window.jdgm.SHOP_DOMAIN = '6c6e33.myshopify.com';
  window.jdgm.PLATFORM = 'shopify';

  // Find product ID from page
  var metaTag = document.querySelector('meta[property="og:image"]');
  var productIdEl = document.querySelector('[data-product-id]');
  var productId = productIdEl ? productIdEl.getAttribute('data-product-id') : '';

  // Create review container
  var container = document.createElement('div');
  container.className = 'page-width';
  container.style.marginTop = '40px';
  container.style.marginBottom = '40px';
  container.innerHTML = '<div class="jdgm-rev-widg" data-id="' + productId + '"></div>';

  // Insert after main product section
  var mainSection = document.querySelector('.shopify-section-template--25713562878234__main') ||
                    document.querySelector('[data-section-type="product"]');
  if (mainSection) {
    mainSection.parentNode.insertBefore(container, mainSection.nextSibling);
  } else {
    // Fallback: append to main content
    var main = document.querySelector('main') || document.querySelector('#MainContent');
    if (main) main.appendChild(container);
  }

  // Load Judge.me scripts
  var s1 = document.createElement('script');
  s1.src = 'https://cdn.judge.me/widget_preloader.js';
  document.body.appendChild(s1);

  setTimeout(function(){
    var s2 = document.createElement('script');
    s2.src = 'https://cdn.judge.me/assets/installed.js';
    document.body.appendChild(s2);
  }, 500);
})();
